var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("h1", { staticClass: "title" }, [
    _vm._v(_vm._s(_vm.$t("error.404"))),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }